import { ArrowDown, ArrowRight, ArrowUp, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, CircleAlert, CircleCheck, CircleHelp, CircleX, Download, ExternalLink, FileText, Filter, Info, Mail, Menu, Minus, Package, Pencil, Plus, Search, ShoppingCart, Trash2, User, X, } from "lucide-react";
/**
 * Curated icon map. Add NEW icons by importing from lucide-react and adding
 * a key here. Components import from this map, not directly from lucide-react,
 * so the icon set stays auditable and the bundle stays minimal.
 */
export const Icons = {
    arrowDown: ArrowDown,
    arrowRight: ArrowRight,
    arrowUp: ArrowUp,
    check: Check,
    chevronDown: ChevronDown,
    chevronLeft: ChevronLeft,
    chevronRight: ChevronRight,
    chevronUp: ChevronUp,
    alert: CircleAlert,
    checkCircle: CircleCheck,
    help: CircleHelp,
    close: CircleX,
    download: Download,
    externalLink: ExternalLink,
    fileText: FileText,
    filter: Filter,
    info: Info,
    mail: Mail,
    menu: Menu,
    minus: Minus,
    package: Package,
    pencil: Pencil,
    plus: Plus,
    search: Search,
    cart: ShoppingCart,
    trash: Trash2,
    user: User,
    x: X,
};
